import { FC, Suspense } from 'react';

import { App } from 'antd';
import { ErrorBoundary } from './lib';
import { Providers } from './providers';
import { AppRouter } from './router';

export const BackOfficeApp: FC = () => (
  <Suspense fallback={<p>loading</p>}>
    <App>
      <Providers>
        <ErrorBoundary>
          <AppRouter />
        </ErrorBoundary>
      </Providers>
    </App>
  </Suspense>
);
